import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateTagMetadata } from '../../api/tag.ts';
import { UpdateTagMetadataRequest } from '../../api/requests/tag-request.ts';

export default function useUpdateTagMetadata(): UseMutationResult<
  Awaited<ReturnType<typeof updateTagMetadata>>,
  Error,
  UpdateTagMetadataRequest
> {
  return useMutation({
    mutationFn: updateTagMetadata,
  });
}
